import {eINVALID} from "./invalidvalue";

export class VariableValue {
  ref: number = 0;
  val: number = eINVALID.eINVALID;
  ahm: number = 0;
  value: string = "++";

  IsInvalid() : boolean
  {
    return this.val == eINVALID.eINVALID;
  }
}
export interface VariableListReceived {
  values: VariableValue[];
}


